/**
 * @readonly
 * @enum {String}
 */
const payoutStructuresEnum = {
    regular: 'regular',
    winner: 'winner',
    top3: 'top3',
}

const defaultPayoutStructure = payoutStructuresEnum.regular;

export {
    payoutStructuresEnum,
    defaultPayoutStructure
}
